export default __webpack_public_path__ + "static/media/about-us-history.88fa668a.avif";